import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setContent } from "../../stores/mainSlice";
import { setLang } from "../../stores/mainSlice";
import { Outlet, useParams } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import { Header } from "./components/Header";

export const Welcome = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (localStorage.getItem("lang") === null) {
      localStorage.setItem("lang", "tm");
    } else {
      dispatch(setLang(localStorage.getItem("lang")));
    }
  }, [dispatch]);
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/main/content/`)
      .then((res) => {
        dispatch(setContent(res.data));
      })
      .then(() => {
        setIsLoading(false);
      });
  }, [params, dispatch]);

  return isLoading === true ? (
    <div id="loader">
      <Spinner animation="border" role="status" style={{ color: "#198754" }}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  ) : (
    <div className="welcome-page">
      <Header />
      <Outlet />
    </div>
  );
};
